import React from "react";
import { useLocation } from "react-router-dom";
import CVLAModuleSubtopic from "../CVLAModuleSubtopic";

const PolarForm = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <CVLAModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Polar Form"
      videos={[
        "https://www.youtube.com/embed/5TkzxaW5BsM",
        "https://www.youtube.com/embed/vvhKKSlP1E0"
      ]}
      takeaways={[]}
      questions={[]}
      exampleVideos={[]}
    />
  );
}

export default PolarForm;
